module.exports = __webpack_public_path__ + "static/img/top_img.70062ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top_img.png
// module id = jSv1
// module chunks = 1